module.exports = __webpack_public_path__ + "public/SiteImages/grey.png?d59084cb";